

import React from 'react';

import RequestProvider from '../../RequestProvider';
import { UploaderConsumer } from '../../Uploader';

import BulkActionModal from '../components/BulkActionModal';

import { updateAssetTagsApi, archiveAssetsApi, unarchiveAssetsApi, deleteAssetsApi } from '../api';

import '../styles/_bulk-actions.scss';
















function BulkActionModalContainer(props) {
  const { withUploader, selectedAssets } = props;

  return (
    <RequestProvider
      requests={{
        updateAssetTags: updateAssetTagsApi,
        archiveAssets: archiveAssetsApi,
        unarchiveAssets: unarchiveAssetsApi,
        deleteAssets: deleteAssetsApi
      }}>

      {(requests) => {
        if (withUploader) {
          return (
            <UploaderConsumer>
              {({ fetchAssets, assetsMap }) =>
              <BulkActionModal
                assetsMap={assetsMap}
                fetchAssets={fetchAssets}
                {...props}
                {...requests} />}


            </UploaderConsumer>);

        }

        const assetsMap = new Map();
        // $FlowFixMe
        const selectedAssetsCopy = [...selectedAssets];

        selectedAssetsCopy.forEach((asset) => {
          const { assetId } = asset;
          assetsMap.set(assetId, asset);
        });

        const selectedAssetsIds = selectedAssetsCopy.map((asset) => asset.assetId);

        return (
          <BulkActionModal
            {...{
              ...props,
              assetsMap,
              selectedAssets: selectedAssetsIds
            }}
            {...requests} />);


      }}
    </RequestProvider>);

}

export default BulkActionModalContainer;